/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCreateUpcomingSaleRequestRequest,
  TCreateUpcomingSaleRequestModel,
  IMappers,
  TCreateUpcomingSaleRequestResponse,
  TCreateUpcomingSaleRequestResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCreateUpcomingSaleRequestModel(
  parameters: TCreateUpcomingSaleRequestRequest,
): TCreateUpcomingSaleRequestModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-flat-view-order',
    pathApi: '/v1/create-upcoming-sale-request/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICreateUpcomingSaleRequestOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCreateUpcomingSaleRequestRequest;
}

export async function fetchCreateUpcomingSaleRequest<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateUpcomingSaleRequestOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCreateUpcomingSaleRequestResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCreateUpcomingSaleRequestModel(parameters),
    config,
  )) as FetchResponse<TCreateUpcomingSaleRequestResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TCreateUpcomingSaleRequestResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCreateUpcomingSaleRequestResponse>;
}
